<template>
  <div>
  <b-tabs content-class = "" >
    <b-tab
        :active="activeBasicData"
        @click="goToBasicData"
    >
      <template #title>
        {{ basicDataLabel }}
        <tab-icon :status="(!form.canSubmit && form.canSubmit !== undefined) ? 'ERROR' :
                           (!readOnlyInputs) ? 'EDITED' : ''"></tab-icon>
      </template>

      <BasicDataEditor
          ref="edit-user"
          data-test-path="edit-users"
          :mode="mode"
          :user-id="userId"
          :editUser="user"
          :form="form"
          :is-email-clicked="isEmailClicked"

          :read-only-inputs="readOnlyInputs"
          @cancel="cancel"
          @ok-no-close="saveBasicData"
          @edit-enable="edit"
          @attachments-saved="attachmentsSaved"
          @send-invitation-email="sendInvitationEmail"
          :cancel-perm="true"
          :edit-perm="true"
          :save-perm="true"
          :show-footer="false"
      >
      </BasicDataEditor>
    </b-tab>
    <b-tab
        :active="!activeBasicData"
        @click.stop = "getRoles()"
    >

      <template #title>
        <span data-test-path="roles"> {{ rolesLabel }}</span>
        <tab-icon :status="(!readOnlyInputsRoles && !errorOwnerFeedback) ? 'EDITED' :
                           errorOwnerFeedback ? 'ERROR' : ''"></tab-icon>
      </template>
      <form-header
          v-if="mode !== 'NEW'"
          :save-enabled="form.canSubmit && errorOwnerFeedback.length <= 0"
          :save-edit-mode="readOnlyInputsRoles ? 'EDIT' : 'SAVE'"
          @save="rolesSave"
          @edit="rolesEdit"
      ></form-header>
      <v-box ref="vbox-roles" :scrollable="true">
        <b-container>
          <b-row>
            <b-col lg="5">
              <b-table
                  hover
                  selectable
                  select-mode="single"
                  id="assigned-roles"
                  responsive="sm"
                  ref="tableAssignedRoles"
                  :items="listsAssigned"
                  :fields="fieldsAssigned"
                  @row-selected="onAssignedRowSelected"
              >
              </b-table>
            </b-col>

            <b-col  class="text-center">
              <b-button
                  data-test-path="move-role"
                  @click="moveRole()"
                  class="button-arrow"
                  variant="plm-action"
                  :disabled = "readOnlyInputsRoles"
              >
                <font-awesome-icon
                    class="arrow d-none d-lg-block"
                    v-if="isListsAvailableActive"
                    icon="arrow-left"
                />
                <font-awesome-icon
                    class="arrow d-none d-lg-block"
                    v-else-if="isListsAssignedActive"
                    icon="arrow-right"
                />
                <font-awesome-icon
                    class="arrow d-block d-lg-none"
                    v-if="isListsAvailableActive"
                    icon="arrow-up"
                />
                <font-awesome-icon
                    class="arrow d-block d-lg-none"
                    v-else-if="isListsAssignedActive"
                    icon="arrow-down"
                />
              </b-button>
            </b-col>

            <b-col lg="5">
              <b-table
                  hover
                  selectable
                  select-mode="single"
                  responsive="sm"
                  ref="tableAvailableRoles"
                  :items="listsAvailable"
                  :fields="fieldsAvailable"
                  @row-selected="onAvailableRowSelected"
              >
              </b-table>
              </b-col>
            </b-row>

            <b-row class="text-center" style="color: #dc3545; margin-top: 15px">
              <b-col>
              <label v-if="errorOwnerFeedback">{{ errorOwnerFeedback }}</label>
              </b-col>
            </b-row>
        </b-container>
      </v-box>
    </b-tab >
    <b-tab
        :active="!activeBasicData"
        @click.stop = "getGroups()"
    >
      <template #title>
        <span data-test-path="groups" > {{$tr('groups','Groups')}}</span>
        <tab-icon :status="!readOnlyInputsGroups ? 'EDITED': ''"></tab-icon>
      </template>
      <form-header
          v-if="mode !== 'NEW'"
          :save-enabled="form.canSubmit"
          :save-edit-mode="readOnlyInputsGroups ? 'EDIT' : 'SAVE'"
          @save="groupsSave"
          @edit="groupEdit"
          data-test-path="tab-groups-header"
      ></form-header>
      <v-box ref="vbox-groups" :scrollable="true">
        <b-container data-test-path="tab-groups">
          <b-row>
            <b-col lg="5">
              <b-table
                  hover
                  selectable
                  select-mode="single"
                  id="assigned-groups"
                  responsive="sm"
                  ref="tableAssignedGroups"
                  :items="listsAssignedGroups"
                  :fields="fieldsAssignedGroups"
                  @row-selected="onAssignedRowSelectedGroup"
              >
              </b-table>
            </b-col>
            <b-col  class="text-center">
              <b-button
                  data-test-path="move-group"
                  @click="moveGroup()"
                  class="button-arrow"
                  variant="plm-action"
                  :disabled = "readOnlyInputsGroups"
              >
                <font-awesome-icon
                    class="arrow d-none d-lg-block"
                    v-if="isListsAvailableActiveGroups"
                    icon="arrow-left"
                />
                <font-awesome-icon
                    class="arrow d-none d-lg-block"
                    v-else-if="isListsAssignedActiveGroups"
                    icon="arrow-right"
                />
                <font-awesome-icon
                    class="arrow d-block d-lg-none"
                    v-if="isListsAvailableActiveGroups"
                    icon="arrow-up"
                />
                <font-awesome-icon
                    class="arrow d-block d-lg-none"
                    v-else-if="isListsAssignedActiveGroups"
                    icon="arrow-down"
                />
              </b-button>
            </b-col>
            <b-col lg="5">
              <b-table
                  data-test-path="tableAvailableGroups"
                  hover
                  selectable
                  select-mode="single"
                  responsive="sm"
                  ref="tableAvailableGroups"
                  :items="listsAvailableGroups"
                  :fields="fieldsAvailableGroups"
                  @row-selected="onAvailableRowSelectedGroup"
              >
              </b-table>
            </b-col>
          </b-row>
        </b-container>
      </v-box>
    </b-tab >
  </b-tabs>
    <FooterNavbar data-test-path="user-footer" >
        <CloseButton :read-only="readOnlyInputs && readOnlyInputsRoles && readOnlyInputsGroups" @close="cancel2"></CloseButton>
        <save-and-close-button
            v-if="(!readOnlyInputs || !readOnlyInputsRoles || !readOnlyInputsGroups)"
            :enabled="form.canSubmit"
            :mode="mode"
            @save="saveAll"
        >
        </save-and-close-button>
    </FooterNavbar>
  </div>
</template>

<script>
import SignIn from "@/components/SignIn";
import Activity from "@/activity/Activity";
import DashboardUserForm from "@/components/users/DashboardUserForm";
import PermissionsSet from "@/server/PermissionsSet";
import BasicDataEditor from "@/components/users/BasicDataEditor";
import VBox from "@/components/VBox";
import LastOwnerCannotBeDeletedException from "@/server/com/silkplm/rpc/exceptions/LastOwnerCannotBeDeletedException";
import SessionManager from "@/utils/SessionManager";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import SaveAndCloseButton from "@/components/navbar/SaveAndCloseButton";
import FormHeader from "@/components/forms/FormHeader";
import TabIcon from "@/components/layout/TabIcon";
import DialogManager from "@/utils/DialogManager";
import {runtimeTr} from "@/utils/Tr";

export default {
  name: "EditUsers",
  components: {
    TabIcon,
    FormHeader, SaveAndCloseButton, FooterButton, FooterNavbar, SignIn, BasicDataEditor, VBox, CloseButton},

  async mounted() {
    if (this.mode === "EDIT_AS_ADMIN") {
      this.user = await this.form.editUser(this.mode, this.userId);
      EventBus.$emit(Events.attachmentLoad);
    } else
      this.form.newUser();

    if(this.user && this.user.id === SessionManager.applicationUser.id) {
      this.$onEvent(Events.roleChanged, async () => await this.getRoles());
    }
    if(!this.activeBasicData){
      await this.getRoles();
      await this.getGroups();
    }
  },

  methods: {

    ...Activity.methods,

    getTitle() {
      if (this.mode === "EDIT_AS_ADMIN")
        return $tr('userAccount','User Account');
      return $tr('newUserAccount','New User Account');
    },

    beforeClose() {
      if(this.user){
        this.setResult(this.user);
      }
    },

    async canClose() {
      if(this.readOnlyInputsRoles && this.readOnlyInputs && this.readOnlyInputsGroups){
        return await DialogManager.canClose(false);
      }
      let unsavedChanges = !this.readOnlyInputsRoles && !this.readOnlyInputs && !this.readOnlyInputsGroups;
      if(unsavedChanges || this.unsavedChanges){
        return await DialogManager.canClose(true);
      }
      return await DialogManager.canClose(false);
    },

    cancel(){
      this.close();
    },

    cancel2(){
      this.unsavedChanges = true;
      this.close();
    },

    goToBasicData(){
      setTimeout( () => {
        this.$refs["edit-user"].$refs.vbox.sizeChanged();
      });
    },

    openAttachments() {
      this.afterStart(async () => {
        await this.$refs["edit-user"].openAttachments();
      });
    },

    rolesEdit(){
      this.readOnlyInputsRoles = false;
    },

    groupEdit(){
      this.readOnlyInputsGroups = false;
    },

    async rolesSave() {
        if(await this.saveRoles()){
          this.readOnlyInputsRoles = true;
        }
    },

    async groupsSave() {
      if(await this.saveGroups()){
        this.readOnlyInputsGroups = true;
      }
    },

    attachmentsSaved(attachmentLists){
      this.form.originalSource.attachments= attachmentLists;
      this.user.attachments = attachmentLists;
    },

    async saveBasicData(attachmentLists) {
      if (this.mode === "EDIT_AS_ADMIN") {
        try {
          this.form.originalSource.attachments= attachmentLists;
          this.user = await this.form.saveUser();
          if(!this.form.isValid){
            if(!this.form.validatedFieldByName("integrationAccount").crossFieldIsValid){
              await DialogManager.info($tr('saveFailed','Save failed'),
                  $tr("editUser.cant.converted","This account can't be converted to Integration type"));
            }
            this.edit();
            return false;
          }
          this.readOnlyInputs = true;
        } catch (e) {
          this.form.parseException(e);
          this.edit();
          return false;
        }
      } else if (this.mode === "NEW") {
        try {
          await this.$refs["edit-user"].prepareSave();
          this.form.originalSource.attachments= attachmentLists;
          this.user = await this.form.saveUser(this.isEmailClicked);
          this.readOnlyInputs = true;
        } catch (e) {
          this.form.parseException(e);
          this.edit();
          return false;
        }
      }
      return true;
    },

    async saveAll(){
      if(await this.saveBasicData(this.$refs["edit-user"].attachmentLists)){
        this.readOnlyInputs = true;
        this.sendInvitationEmail();
        if(await this.saveRoles()){
          if(await this.saveGroups()){
            this.readOnlyInputsGroups = true;
          }
          this.readOnlyInputsRoles = true;
          this.cancel();
          return;
        } else {
          this.activeBasicData = false;
        }
        if(await this.saveGroups()){
          this.readOnlyInputsGroups = true;
          this.cancel();
          return;
        } else {
          this.activeBasicData = false;
        }
        this.readOnlyInputsGroups = true;
        this.readOnlyInputsRoles = true;
        this.cancel();
      } else {
        this.activeBasicData = true;
      }
    },

    edit(){
      this.readOnlyInputs = false;
    },

    async getRoles() {

      setTimeout( () => {
        this.$refs["vbox-roles"].sizeChanged();
      });
      if (this.listsAvailable.length === 0 && this.listsAssigned.length === 0) {
        if(this.user){
          this.listsAvailable = await Rpc.Users.listAvailableRoles(this.user);
          this.listsAvailable.forEach(role => {
            role.name = runtimeTr("api.roles."+role.name, role.name);
          })
          this.listsAvailable.sort((a, b) => (a.name > b.name) ? 1 : -1);
          this.listsAssigned = await Rpc.Users.listAssignedRoles(this.user);
          this.listsAssigned.forEach(role => {
            role.name = runtimeTr("api.roles."+role.name, role.name);
          })
          this.listsAssigned.sort((a, b) => (a.name > b.name) ? 1 : -1);
        }
        else{
          this.listsAvailable = await Rpc.Users.listAllRoles();
          this.listsAvailable.forEach(role => {
            role.name = runtimeTr("api.roles."+role.name, role.name);
          })
          this.listsAvailable.sort((a, b) => (a.name > b.name) ? 1 : -1);
        }
      }
    },

    async getGroups() {
      setTimeout( () => {
        this.$refs["vbox-groups"].sizeChanged();
      });
      if (this.listsAvailableGroups.length === 0 && this.listsAssignedGroups.length === 0) {
        if(this.user){
          this.listsAvailableGroups = await Rpc.Users.listAvailableGroups(this.user);
          this.listsAvailableGroups.forEach(group =>{
            group.name = runtimeTr("api.groups."+group.name,group.name);
          })
          this.listsAvailableGroups.sort((a, b) => (a.name > b.name) ? 1 : -1);
          this.listsAssignedGroups = await Rpc.Users.listAssignedGroups(this.user);
          this.listsAssignedGroups.forEach(group =>{
            group.name = runtimeTr("api.groups."+group.name,group.name);
          })
          this.listsAssignedGroups.sort((a, b) => (a.name > b.name) ? 1 : -1);
        }
        else{
          this.listsAvailableGroups = await Rpc.Users.listAllGroups();
          this.listsAvailableGroups.forEach(group =>{
            group.name = runtimeTr("api.groups."+group.name,group.name);
          })
          this.listsAvailableGroups.sort((a, b) => (a.name > b.name) ? 1 : -1);
        }
      }
    },

    async saveRoles() {
      try {
        if(this.listsAvailable.length !== 0 || this.listsAssigned.length !== 0){
          await Rpc.Users.changeUserRole(this.user, this.listsAssigned, this.listsAvailable);
          this.errorOwnerFeedback = '';
          return true;
        }
      } catch (e) {
        this.rolesEdit();
        if (e instanceof LastOwnerCannotBeDeletedException)
          this.errorOwnerFeedback = $tr('editUser.cannot.operation',
              'The operation cannot be performed because the organization must have at least one owner.');
      }
      return false;
    },

    async saveGroups() {
      try {
        if(this.listsAvailableGroups.length !== 0 || this.listsAssignedGroups.length !== 0) {
          await Rpc.Users.changeUserGroup(this.user, this.listsAssignedGroups, this.listsAvailableGroups);
          return true;
        }
      } catch (e) {
        this.groupEdit();
      }
      return false;
    },

    moveRole() {
      this.errorOwnerFeedback = '';
      if (this.isListsAvailableActive)
        this.moveRoleFromAvailableToAssigned();
      else
        this.moveRoleFromAssignedToAvailable();
    },

    moveGroup() {
      if (this.isListsAvailableActiveGroups)
        this.moveGroupFromAvailableToAssigned();
      else
        this.moveGroupFromAssignedToAvailable();
    },

    moveRoleFromAvailableToAssigned() {
      if (this.selectedRole) {
        if (this.selectedRole.name === runtimeTr("api.roles.Owner","Owner")) {
          if (this.form.email.value === '') {
            this.errorOwnerFeedback = $tr('editUser.requires.user.email',
                'Assigning the owner role requires that the user has an email.');
            return;
          } else if (!this.form.email.isValid) {
            this.errorOwnerFeedback = $tr('editUser.requires.owner.email',
                'Assigning the owner role requires valid email.');
            return;
          }
        }
        this.listsAssigned.push(this.selectedRole);
        let index = this.listsAvailable.indexOf(this.selectedRole);
        if (index !== -1) {
          this.listsAvailable.splice(index, 1);
        }
      }
    },

    moveGroupFromAvailableToAssigned() {
      if (this.selectedGroup) {
        this.listsAssignedGroups.push(this.selectedGroup);
        let index = this.listsAvailableGroups.indexOf(this.selectedGroup);
        if (index !== -1) {
          this.listsAvailableGroups.splice(index, 1);
        }
      }
    },

    moveRoleFromAssignedToAvailable() {
      if (this.selectedRole) {
        this.listsAvailable.push(this.selectedRole);
        let index = this.listsAssigned.indexOf(this.selectedRole);
        if (index !== -1) {
          this.listsAssigned.splice(index, 1);
        }
      }
    },

    moveGroupFromAssignedToAvailable() {
      if (this.selectedGroup) {
        this.listsAvailableGroups.push(this.selectedGroup);
        let index = this.listsAssignedGroups.indexOf(this.selectedGroup);
        if (index !== -1) {
          this.listsAssignedGroups.splice(index, 1);
        }
      }
    },

    onAssignedRowSelected(items) {
      this.$refs.tableAvailableRoles.clearSelected();
      this.isListsAssignedActive = true;
      this.isListsAvailableActive = false;
      this.getSelectedRow(items);
    },

    onAssignedRowSelectedGroup(items) {
      this.$refs.tableAvailableGroups.clearSelected();
      this.isListsAssignedActiveGroups = true;
      this.isListsAvailableActiveGroups = false;
      this.getSelectedRowGroups(items);
    },

    onAvailableRowSelected(items) {
      this.$refs.tableAssignedRoles.clearSelected();
      this.isListsAvailableActive = true;
      this.isListsAssignedActive = false;
      this.getSelectedRow(items);
    },

    onAvailableRowSelectedGroup(items) {
      this.$refs.tableAssignedGroups.clearSelected();
      this.isListsAvailableActiveGroups = true;
      this.isListsAssignedActiveGroups = false;
      this.getSelectedRowGroups(items);
    },

    getSelectedRow(items) {
      let selectedRow = items[0];
      if (selectedRow)
        this.selectedRole = selectedRow;
      else
        this.selectedRole = null;
    },

    getSelectedRowGroups(items) {
      let selectedRow = items[0];
      if (selectedRow)
        this.selectedGroup = selectedRow;
      else
        this.selectedGroup = null;
    },

    sendInvitationEmail() {
      this.isEmailClicked = true;
    },

  },

  props: {
    mode:               {type: String,  default:null },
    userId:             {type: String,  default: ""},
    activeBasicData:    {type: Boolean,  default:true },
  },

  data: function(){ return {
    listsAssigned: [],
    listsAvailable: [],
    listsAssignedGroups: [],
    listsAvailableGroups: [],
    fieldsAssigned: [{ key:'name', translationLabel: 'Assigned roles', class: 'text-center'}],
    fieldsAvailable: [{ key:'name', translationLabel: 'Available roles', class: 'text-center'}],
    fieldsAssignedGroups: [{ key:'name', translationLabel: 'Assigned groups', class: 'text-center'}],
    fieldsAvailableGroups: [{ key:'name', translationLabel: 'Available groups', class: 'text-center'}],
    selectedRole: null,
    selectedGroup: null,
    isListsAssignedActive: false,
    isListsAvailableActive: true,
    isListsAssignedActiveGroups: false,
    isListsAvailableActiveGroups: true,
    user: null,
    form: new DashboardUserForm(),
    permissions : new PermissionsSet(),
    errorOwnerFeedback: '',
    isEmailClicked: false,
    readOnlyInputs: this.mode !== 'NEW',
    readOnlyInputsRoles: this.mode !== 'NEW',
    readOnlyInputsGroups: this.mode !== 'NEW',
    basicDataLabel: $tr("editUsers.basicData", "Basic Data"),
    rolesLabel: $tr("editUsers.rolesLabel", "Roles")
  }}
}
</script>
